import { render, staticRenderFns } from "./SearchPreFiltersContent.vue?vue&type=template&id=6208115e&scoped=true&"
import script from "./SearchPreFiltersContent.vue?vue&type=script&lang=ts&"
export * from "./SearchPreFiltersContent.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPreFiltersContent.vue?vue&type=style&index=0&id=6208115e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208115e",
  null
  
)

export default component.exports